import React from 'react';
import { Deck } from './components/Deck';
import { Meta } from './components/Meta';
export function App() {
  return <>
      <Meta data-id="element-0" />
      <Deck data-id="element-1" />
    </>;
}